<div *ngIf="selectedCert" class="signImageConfig">
  <div id="SignImageConfig3" #SignImageConfig3>
    <ng-container *ngTemplateOutlet="ImageConfig"></ng-container>
  </div>
</div>
<form #f="ngForm" (ngSubmit)="f.form.valid && onClickConfirmButton()" appFocusFirstElement class="w-100">
  <h2 mat-dialog-title mat-dialog-draggable-title>{{'digital_certificate_management.select_certificate' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <mat-dialog-content class="select-certificate">
    <i>{{getMessageSelectCert()}}</i>
    <div class="row mt-3">
      <div class="col-md-12 pb-3">
        <ng-container *ngIf="certificates== undefined || certificates.length == 0; else hasCertificates">
          {{'digital_certificate_management.not_exist_certificate_v2' | translate}}
        </ng-container>
        <ng-template #hasCertificates>
          <ng-container *ngFor="let item of certificates">
            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group border-bottom"
                           [(ngModel)]="typeCertificate" [ngModelOptions]="{standalone: true}"
                           *ngIf="(item.type != 0 && item.type != 4) || isHsmPermission">
            <mat-radio-button class="example-radio-button" [value]="item.type" [ngSwitch]="item.type"
                              (change)="onChangeType()">
                              <!-- this.signType === SignDocumentComponent.SIGN_SLOT -->
              <ng-container *ngSwitchCase="1">
                {{'digital_certificate_management.rd_certificate_type.cbx_usb' | translate}}
                <i>({{(signType === "slot") ? getMessageUsbTokenThreshold() : ''}})</i>
              </ng-container>
              <ng-container *ngSwitchCase="2">
                {{'digital_certificate_management.rd_certificate_type.cbx_sim_ca' | translate}}
              </ng-container>
                <ng-container *ngSwitchCase="4">
                {{'digital_certificate_management.rd_certificate_type.cbx_hsm' | translate}}
              </ng-container>
                <ng-container *ngSwitchCase="0">
                {{'digital_certificate_management.rd_certificate_type.cbx_server' | translate}}
                </ng-container>
              <ng-container *ngSwitchCase="3">
                {{'digital_certificate_management.rd_certificate_type.cbx_otp' | translate}}
              </ng-container>

              <ng-container *ngSwitchCase="signTypes.CLOUD_CA">
                {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' | translate}}
                <i>({{getMessageCloudCaThreshold()}})</i>
              </ng-container>

            </mat-radio-button>
            <div class="container" *ngIf="item.type == typeCertificate">
              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
              (ngModelChange)="setIssueTo($event)"  [(ngModel)]="selectedCert" [ngModelOptions]="{standalone: true}">
                <!-- Not OTP -->
                <mat-table [dataSource]="item.listCert" *ngIf="item.type != 3; else otp">
                  <!-- Chủ thể CTS column -->
                  <ng-container matColumnDef="issuedTo">
                    <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                     style="max-width: 50%;">
                      {{'digital_certificate_management.issuedTo_name' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom align-middle"
                              style="max-width: 50%" matTooltip="{{cert.issuedTo}}">
                      <mat-radio-button class="ml-2 mt-2 mat-header-cell-center" [value]="cert">
                      </mat-radio-button>
                      <span class="fix-width">{{cert.issuedTo}}</span>
                    </mat-cell>
                  </ng-container>

                  <!-- Mã số thuế column -->
                  <ng-container matColumnDef="taxCode">
                    <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                     style="max-width: 30%;">
                      {{'digital_certificate_management.mst' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom number-cell-right"
                              style="max-width: 30%;" matTooltip="{{cert.taxCode}}">
                      {{cert.taxCode}}
                    </mat-cell>
                  </ng-container>

                  <!-- Số điện thoại -->
                  <ng-container matColumnDef="phoneNumber">
                    <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                     style="max-width: 30%;"
                                     [ngStyle]="{'display': typeCertificate == 2 ? null : 'none'}">
                      {{'digital_certificate_management.lbl_phone' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom number-cell-right"
                              style="max-width: 30%;" [ngStyle]="{'display': typeCertificate == 2 ? null : 'none'}"
                              matTooltip="{{cert.phoneNumber}}">
                      {{cert.phoneNumber}}
                    </mat-cell>
                  </ng-container>

                  <!-- Ngày hoàn thành column -->
                  <ng-container matColumnDef="expireDate">
                    <mat-header-cell *matHeaderCellDef class="co-col" [ngClass]="'mat-cell-non-boder-bottom'" style="max-width: 25%;">
                      {{'headertable.end_of_activate_date' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let cert" class="number-cell-right" [ngClass]="'mat-cell-non-boder-bottom'"
                              style="max-width: 25%;" matTooltip="{{cert.expireDate | dateformat}}">
                      {{cert.expireDate | dateformat}}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="item.type == signTypes.CLOUD_CA ? columnsToDisplayCA : columnsToDisplay;"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: item.type == signTypes.CLOUD_CA ? columnsToDisplayCA : columnsToDisplay;"></mat-row>
                </mat-table>

                <!-- OTP -->
                <ng-template #otp>
                  <h6><strong>{{'digital_certificate_management.phone_number' | translate}}</strong></h6>
                  <mat-radio-button class="example-radio-button w-100" *ngFor="let cert of item.listCert"
                                    [value]="cert">
                    <span style="font-size: 16px;">{{cert.phoneNumber}}</span>
                  </mat-radio-button>
                </ng-template>

              </mat-radio-group>
            </div>
          </mat-radio-group>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button type="submit" [disabled]="!selectedCert" color="primary">
      <mat-icon class="mr-0">gesture</mat-icon>
      {{'button.sign' | translate}}
    </button>
  </mat-dialog-actions>
</form>
<ng-template #ImageConfig>
  <div class="image-config_view__content">
    <div id="imageConfigContainer">
      <ng-container *ngFor="let key of getConfigKeyList()">
        <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
      </ng-container>

      <div *ngIf="signConfig.greenTick.enabled" class="green-tick">
        <svg width="158" height="116" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z" fill="#52C41A"/>
        </svg>  
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
  <div *ngIf="showConfig(data)" class="view-content-item" style="font-family: Roboto">
    <ng-container *ngIf="data == 'signatureImage' || data == 'isDraw'; else displayColon"></ng-container>
    <ng-template #displayColon>
      <div *ngIf="data !== 'signatureImage' || data !== 'isDraw'" class="label">{{signConfig[data].label | translate}}:</div>&nbsp;
    </ng-template>
    <div align="start" style="word-break: break-word; white-space: pre-wrap;">
      <ng-container>
        {{signConfig[data].value}}
      </ng-container>
    </div>
  </div>
</ng-template>
